import { TokenHelper } from '../../common/utils/TokenHelper';
import Preloader from '../../webparts/Preloader';
import 'iframe-resizer';
import './index.scss';
import { MeetingHelper } from '../../common/utils/MeetingHelper';
import { SiteHelper } from '../../common/utils/SiteHelper';

const MeetingEmbed = (element) => {
    if (!element) {
        return;
    }

    const container = element.querySelector('.js-virtual-meeting');
	if(!container) {
		return;
	}
		
    const classId = container.dataset.linkIdClass || 'js-virtual-meeting-link';
	let link = null;
	//if(classId) {	
		link = element.querySelector(`.${classId}`);
	//}
	
	// if(!link) {
	// 	link = element.querySelector('.js-virtual-meeting-link');
	// }
	
    if (!link) {
        return;
    }

    let meetingUrl = MeetingHelper.getLink(classId);
    const tokenKey = link.dataset.tokenParamName;
    const trustedOrigins = (link.dataset.origins || '').split('|');
    const iframe = container.querySelector('.ada-meeting__iframe');

    //append token to meeting url
    meetingUrl = TokenHelper.append(meetingUrl, tokenKey);
    
    //load a preloader while the iframe is loading and hide it after it has loaded
    const loader = new Preloader();
    loader.show();

    const hideLoader = () => {
        loader.hide();
    };

	const removeIframeId = (iframe) => {
        loader.IframeIdRemove(iframe);
    };
	
	
    iframe.onload = () => {
        hideLoader();
		removeIframeId(iframe);
    };
           
    //redirect safari users to Mediasite if they directly try to access the page
    const isSafari = SiteHelper.isSafariUser();
    if (isSafari) {
        window.location.href = meetingUrl;
    }

    //load content in the iframe
    iframe.setAttribute('src', meetingUrl);

    try {
        window.iFrameResize({ log: false, heightCalculationMethod: 'lowestElement', checkOrigin: trustedOrigins }, iframe);
    } catch (err) {
        hideLoader();
        iframe.parentNode.classList.add('ada-meeting__iframe-container--responsive-fallback');
    }
};

export default MeetingEmbed;


// WEBPACK FOOTER //
// ./src/nams2020/webparts/MeetingEmbed/index.js